import { CLIENT_SERVICES, USER_SERVICES } from 'constants/serviceLevels';
import { User } from 'hooks/useUsers';
import { isPrimaryUser } from './roles';

type ServiceLevel = User['serviceLevel'];

export const isUserServiceLevel = (serviceLevel: ServiceLevel) =>
  serviceLevel === USER_SERVICES;

export const isClientServiceLevel = (serviceLevel?: ServiceLevel | null) =>
  serviceLevel === CLIENT_SERVICES;

// Accepts any user-like value carrying an id and an object `role` with a
// displayName — satisfied by both the /users list shape (hooks/useUsers) and
// the /users/me auth shape (state/auth AuthUser), which only differ elsewhere.
export const isEditable = (
  user: { id: number },
  currentUser?: { id: number; role: { displayName: string } } | null
) =>
  currentUser &&
  (user.id === currentUser.id || isPrimaryUser(currentUser.role.displayName));
